import Modal from "../Modals/Modal";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";


const AlertSavePage = ({btnOkAction, unsavedPage, setTargetRedirectLink, targetRedirectLink}) => {
    const [alertSave, setAlertSave] = useState(false)


    const history = useHistory()

    useEffect(() => {
        if (unsavedPage) {
            history.block((block) => {
                if (block.pathname === history.location.pathname) {
                    return true
                }
                setTargetRedirectLink(block.pathname)
                setAlertSave(true)
                return false
            })

            return
        }
        history.block(true)

    }, [unsavedPage, history.location.pathname])


    const btnOkAndRedirect = () => {
        setAlertSave(false)
        btnOkAction()
    }

    const skipSaveHandle = () => {
        history.block(true)
        history.push(targetRedirectLink)
    }

    return (

        <Modal btnOkAction={btnOkAndRedirect}
               show={alertSave}
               btnCancelAction={skipSaveHandle}
               textBtnCancel={"Продолжить без сохранения"}
               textBtnOk={"Сохранить"}
               title={"Внимание:"}>

            Вы пытаетесь покинуть страницу не сохранив внесенные изменения
        </Modal>

    )
}

export default AlertSavePage